<h2 mat-dialog-title>Configurar {{data.arte.nombre_archivo}}</h2>

<mat-dialog-content>

    <table class="table table-bordered">

        <thead>
            <tr>
                <th>Página</th>
                <th>Nombre Operativo</th>
            </tr>
        </thead>

        <tbody>

            <tr *ngFor="let item of paginas; let i = index">

                <td>
                    {{ i + 1 }}
                </td>


                <td>

                    <mat-form-field appearance="outline" class="w-100">

                        <mat-select [(ngModel)]="item.materialId" placeholder="Seleccionar">

                            <mat-option
                                *ngFor="let opcion of materiales"
                                [value]="opcion.id">

                                {{ opcion.nombre }}

                            </mat-option>

                        </mat-select>

                    </mat-form-field>

                </td>

                

            </tr>

        </tbody>

    </table>

</mat-dialog-content>

<mat-dialog-actions align="end">

    <button
        mat-button
        (click)="cancelar()">
        Cancelar
    </button>

    <button
        mat-raised-button
        color="primary"
        (click)="guardar()">
        Guardar
    </button>

</mat-dialog-actions>
